import Photo from './photo';
import Location from './location';
import * as utils from '../functions/utils';

interface IApiCategory {
  IsMatch?: boolean;
  Value?: number;
  Text?: string;
  TextAbbr?: string;
  ListID?: number;
}

class Category {
  isMatch: boolean;
  value: number;
  text: string;
  textAbbr: string;
  listId: number;

  constructor() {
    this.isMatch = false;
    this.value = 0;
    this.text = '';
    this.textAbbr = '';
    this.listId = 0;
  }

  static mappingObject(_obj: IApiCategory): Category {
    const obj = new Category();
    obj.isMatch = _obj.IsMatch || false;
    obj.value = _obj.Value || 0;
    obj.text = _obj.Text || '';
    obj.textAbbr = _obj.TextAbbr || '';
    obj.listId = _obj.ListID || 0;

    return obj;
  }

  static mappingArray(_arr: IApiCategory[]): Category[] {
    const arr: Category[] = [];

    if (Array.isArray(_arr)) {
      _arr.forEach(i => {
        arr.push(Category.mappingObject(i));
      });
    }

    return arr;
  }
}

export interface IApiClubDetail {
  Detail?: {
    DisplayEmail?: string;
    Website?: string;
    Description?: string;
    ClubID?: number;
    ClubName?: string;
    Location?: any;
    Categories?: IApiCategory[];
    Rating?: number;
    MainPhoto?: any;
    IsFeatured?: boolean;
    IsSponsored?: boolean;
  };
  HasRated?: boolean;
  RateScore?: number;
  HasCommented?: boolean;
}

export default class ClubDetail {
  detail: any;
  hasRated: boolean;
  hasCommented: boolean;
  rateScore: number;

  constructor() {
    this.detail = null;
    this.hasRated = false;
    this.hasCommented = false;
    this.rateScore = 0;
  }

  static mappingObject(_obj: IApiClubDetail): ClubDetail {
    const obj = new ClubDetail();
    obj.detail =
      (_obj.Detail && {
        displayEmail: _obj.Detail.DisplayEmail || '',
        website: _obj.Detail.Website || '',
        description: utils.convertEnterStringToTagHTML(_obj.Detail.Description) || '',
        clubId: _obj.Detail.ClubID || -1,
        clubName: _obj.Detail.ClubName || '',
        location:
          (_obj.Detail.Location &&
            // Fixed typo: masspingObject -> mappingObject
            Location.mappingObject(_obj.Detail.Location)) ||
          undefined,
        categories: (_obj.Detail.Categories && Category.mappingArray(_obj.Detail.Categories)) || [],
        rating: _obj.Detail.Rating || 0,
        mainPhoto: (_obj.Detail.MainPhoto && Photo.mappingObject(_obj.Detail.MainPhoto)) || {},
        isFeatured: _obj.Detail.IsFeatured || false,
        isSponsored: _obj.Detail.IsSponsored || false,
      }) ||
      null;
    obj.hasRated = _obj.HasRated || false;
    obj.rateScore = _obj.RateScore || 0;
    obj.hasCommented = _obj.HasCommented || false;

    return obj;
  }
}
